<template>
  <div
    v-if="currentView === 'attendance'"
    class="totalHrsContainer"
  >
    <div
      v-for="val in totalRows"
      :key="val"
      class="totalRow"
    >
      <span>
        <span>
          {{ val }}
        </span>
      </span>
    </div>
  </div>
  <div
    v-else-if="currentView === 'allocations'"
    class="totalHrsContainer"
    style="justify-content: center;"
  >
    <div
      v-for="val in totalRows"
      :key="val"
      class="totalCell"
    >
      <span>
        <span>
          {{ val }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'TotalHoursCellRenderer',
  setup(props) {
    const currentView = props.params?.currentFolder?.name;

    const totalRows = computed(() => {
      let retVal = [];
      if (currentView !== null && currentView !== undefined) {
        if (currentView === 'attendance') {
          if (props.params['data'] !== undefined && props.params['data'].day === undefined) {
            const att = props.params['data'].att_sum?.[0];
            if (att != null) {
              const overtimeHours = ((att.overtime_minutes || 0) / 60).toFixed(2);
              const formattedOvertimeDays = ((att.overtime_minutes || 0) / 480).toFixed(2);
              const result = {
                TPD: att.TPD || 0,
                OT: `${overtimeHours}(${formattedOvertimeDays} days)`,
                ...att.attendance_type_summary
              };

              Object.entries(result).forEach(([key, value]) => {
                if ((typeof value === 'number' && value > 0) || (typeof value === 'string' && value !== '0.00(0.00 days)')) {
                  retVal.push(`${key}:${value}`);
                }
              });
            }
          }
        } else if (currentView === 'allocations') {
          let regularDays = 0
          for (const key in props.params.data) {
            if (key !== 'employees') {
              if (!props.params.data[key]?.isLeave) {
                if ('allocation_type' in props.params.data[key] && props.params.data[key].allocation_type?.[0]?.code !== 'WO') {
                  regularDays++;
                }
              }
            }
          }
          retVal = 'R:' + regularDays;
        }
      }
      return retVal;
    });

    return { currentView, totalRows };
  }
}
</script>

<style>
.ag-cell .totalHrsContainer {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.ag-cell .totalHrsContainer .totalRow {
  height: 20px;
  font-size: 12px;
  margin: 5px;
}

.ag-cell .totalCell {
  height: 20px;
  margin: 1px;
  font-size: 12px;
}
</style>
